import styled from '@emotion/styled';
import { getStyles } from './styles';
import { theme } from '../../theme';
export const StyledInlineAlert = styled.div `
	${({ variant }) => getStyles(variant)};

	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: space-between;
	padding: 1rem;
	line-height: 1.4rem;
	gap: ${theme.spacing.space40};
	border-radius: ${theme.radii.radii30};

	@media screen and (max-width: ${() => theme.breakpoints.sm.min}) {
		flex-direction: column;
	}

	h6 {
		${theme.typography.IM90}
		line-height: ${theme.typography.lineHeight.md};
		margin: 0px;
		display: flex;
		align-items: center;
	}

	p {
		${theme.typography.IR90}
		line-height: ${theme.typography.lineHeight.md};
		margin: 0px;
		display: flex;
		align-items: center;
		word-break: break-word;
	}

	${({ style }) => (style ? Object.assign({}, style) : {})};
`;
export const ActionButtonWrapper = styled.div `
	margin-left: 0px;
	flex-shrink: 0;

	@media screen and (max-width: ${() => theme.breakpoints.sm.min}) {
		margin-left: 2rem;
	}
`;
export const JSXContent = styled.div `
	a {
		color: ${theme.colors.BB100};
		text-decoration: none;
	}

	a:hover {
		color: ${theme.colors.BB110};
	}

	a:visited {
		color: ${theme.colors.PU100};
	}
`;
//# sourceMappingURL=InlineAlert.styled.js.map